import { render, staticRenderFns } from "./enrollment-wrapper.vue?vue&type=template&id=2f78a964&scoped=true&"
import script from "./enrollment-wrapper.ts?vue&type=script&lang=ts&"
export * from "./enrollment-wrapper.ts?vue&type=script&lang=ts&"
import style0 from "./enrollment-wrapper.scss?vue&type=style&index=0&id=2f78a964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78a964",
  null
  
)

export default component.exports